import { createTheme } from '@material-ui/core/styles'

export const theme = createTheme({
  checkbox: {
    blue: {
      color: '#1772F5',
    },
    green: {
      color: '#0F9F03',
    },
    lightGreen: {
      color: '#21D284',
    },
    rose: {
      color: '#D715A1',
    },
    yellow: {
      color: '#E0CA05',
    },
    orange: {
      color: '#E5911C',
    },
    black: {
      color: '#151F31',
    },
  },
})
